export default __webpack_public_path__ + "static/media/Calendar_perspective_matte_s.6b5c6593.png";